export default __webpack_public_path__ + "static/media/list.a9a1e2c2.png";